import React from "react";
import { Result, Button } from "antd";
import { FormattedMessage } from "react-intl";
import { useIntl } from "react-intl";

const NoMoreConflicts = (props) => {
  const { onCancel, onCommit, createLoading } = props;
  const intl = useIntl();
  return (
    <Result
      status="success"
      title={intl.formatMessage({
        id: "app.absences.no_more_conflicts",
      })}
      subTitle={intl.formatMessage({
        id: "app.absences.no_more_conflicts_explanation",
      })}
      extra={[
        <Button type="text" onClick={onCancel}>
          <FormattedMessage id={`app.actions.cancel`} />
        </Button>,
        <Button
          type="primary"
          onClick={onCommit}
          loading={createLoading}
          disabled={createLoading}
        >
          <FormattedMessage id={`app.actions.save_employee_absences`} />
        </Button>,
      ]}
    />
  );
};

export default NoMoreConflicts;
